import React from 'react';

const TimePad = ({ num }) => {
  return <span className="w-[25px] h-[25px] px-[3px] bg-white-8 text-center mx-[2px]">{num}</span>;
};

export default TimePad;
